// extracted by mini-css-extract-plugin
export default {"customButtonLink":"CustomButtonLink_customButtonLink__ZFVHw","customButtonLink--fullWidth":"CustomButtonLink_customButtonLink--fullWidth__EFXLS"};